<template>
    <li class="stats__item">
        <div class="stats__number">{{ formattedValue }}</div>
        <div class="stats__stat">{{ label }}</div>
    </li>
</template>

<script setup>
import { computed } from 'vue';

const { value, label, type } = defineProps({
    value: Number,
    label: String,
    type: String
});

const formattedValue = computed(() => {
    if (type === 'percent') {
        return Math.round(value * 100) + '%';
    } else {
        return value;
    }
});
</script>
